module.exports = __webpack_public_path__ + "static/media/receipt-zhang.5f169476.jpg";